export default "__VITE_ASSET__25d2272a__"